var _metadata, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.15331763141455 41.395658065816974",
    width: 50.15331763141455,
    height: 41.395658065816974,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(8.790299836096665 23.520317849906235) rotate(45 7.605235785252432 1.4394174290997341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.72 0 C4.22 0, 7.73 0, 14.49 0 C14.97 0, 15.21 0.24, 15.21 0.72 C15.21 1.15, 15.21 1.59, 15.21 2.16 C15.21 2.64, 14.97 2.88, 14.49 2.88 C9.64 2.88, 4.78 2.88, 0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 C0 1.65, 0 1.15, 0 0.72 C0 0.24, 0.24 0, 0.72 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#005e79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72 0 C3.9 0, 7.09 0, 14.49 0 M0.72 0 C5.89 0, 11.06 0, 14.49 0 M14.49 0 C14.97 0, 15.21 0.24, 15.21 0.72 M14.49 0 C14.97 0, 15.21 0.24, 15.21 0.72 M15.21 0.72 C15.21 1.19, 15.21 1.66, 15.21 2.16 M15.21 0.72 C15.21 1.18, 15.21 1.63, 15.21 2.16 M15.21 2.16 C15.21 2.64, 14.97 2.88, 14.49 2.88 M15.21 2.16 C15.21 2.64, 14.97 2.88, 14.49 2.88 M14.49 2.88 C10.99 2.88, 7.48 2.88, 0.72 2.88 M14.49 2.88 C10.17 2.88, 5.85 2.88, 0.72 2.88 M0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 M0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 M0 2.16 C0 1.64, 0 1.12, 0 0.72 M0 2.16 C0 1.69, 0 1.23, 0 0.72 M0 0.72 C0 0.24, 0.24 0, 0.72 0 M0 0.72 C0 0.24, 0.24 0, 0.72 0",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(15.76589112131785 19.258411603808725) rotate(135 13.689597477188101 1.4394174290997341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.72 0 C9.09 0, 17.47 0, 26.66 0 C27.14 0, 27.38 0.24, 27.38 0.72 C27.38 1.04, 27.38 1.36, 27.38 2.16 C27.38 2.64, 27.14 2.88, 26.66 2.88 C18.1 2.88, 9.54 2.88, 0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 C0 1.68, 0 1.2, 0 0.72 C0 0.24, 0.24 0, 0.72 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#005e79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72 0 C9.18 0, 17.65 0, 26.66 0 M0.72 0 C10.83 0, 20.93 0, 26.66 0 M26.66 0 C27.14 0, 27.38 0.24, 27.38 0.72 M26.66 0 C27.14 0, 27.38 0.24, 27.38 0.72 M27.38 0.72 C27.38 1.12, 27.38 1.53, 27.38 2.16 M27.38 0.72 C27.38 1.25, 27.38 1.78, 27.38 2.16 M27.38 2.16 C27.38 2.64, 27.14 2.88, 26.66 2.88 M27.38 2.16 C27.38 2.64, 27.14 2.88, 26.66 2.88 M26.66 2.88 C20.81 2.88, 14.95 2.88, 0.72 2.88 M26.66 2.88 C20.74 2.88, 14.81 2.88, 0.72 2.88 M0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 M0.72 2.88 C0.24 2.88, 0 2.64, 0 2.16 M0 2.16 C0 1.78, 0 1.4, 0 0.72 M0 2.16 C0 1.67, 0 1.19, 0 0.72 M0 0.72 C0 0.24, 0.24 0, 0.72 0 M0 0.72 C0 0.24, 0.24 0, 0.72 0",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a564062dfd1c826418ede0ba8ca28870.svg";
export { ForwardRef as ReactComponent };